import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import Image from "next/image";
import partenaLogo from "public/images/partenaLogo.svg";
import partenaLogoBlue from "public/images/partenaLogoBlue.svg";

function LogoElement({
  variant,
  onClick,
}: {
  variant: "blue" | "white";
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
}) {
  return (
    <>
      <Box
        onClick={onClick}
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          cursor: "pointer",
          textDecoration: "none",
        }}
      >
        <Image
          alt="logo"
          src={variant == "white" ? partenaLogo : partenaLogoBlue}
        />
      </Box>
    </>
  );
}

export default LogoElement;
